import { useForm } from "react-hook-form";
import { FaAngleRight } from "react-icons/fa6";
import {
  addData,
  getData,
  formService,
  getBtnEmmit,
  setConfirmationModal,
  formResetService,
} from "./setter-form-service";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

function SetterTopClientForm() {
  const [destinationArr, setDestinationArr] = useState([]);
  const [inputConsignerValue, setInputConsignerValue] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");
  const [consigneeArr, setConsigneeArr] = useState([]);
  const [numberOfPallets, setNumberOfPallets] = useState(0);
  const [palletWeights, setPalletWeights] = useState([]);
  const [totalPieces, setTotalPieces] = useState(0);
  const [topClientsArr, setTopClientsArr] = useState([]);

  const {
    register,
    handleSubmit,
    reset,
    unregister,
    setValue,
    trigger,
    watch,
    formState: { errors, isSubmitted },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: { number_pallets: "" },
  });

  let formBtnClick = false;
  const inputConsignee = useRef(null);
  const consigneName = watch("consigne_name");

  useEffect(() => {
    const subscription = formService.formSubmitSubject.subscribe(async () => {
      const isValidForm = await trigger();
      if (isValidForm && getBtnEmmit()) {
        handleSubmit(setterSubmit)();
      } else if (!isValidForm && getBtnEmmit()) {
        if (getData().length < 1) {
          handleSubmit(setterSubmit)();
        } else {
          setConfirmationModal(true);
          return;
        }
      }
    });

    return () => subscription.unsubscribe();
  }, [handleSubmit, trigger]);

  useEffect(() => {
    getDestinations();
    getTopClients();
  }, []);

  // Efecto para manejar el debounce y la búsqueda
  useEffect(() => {
    // Resetear estados cuando el campo consigne_name se vacía (incluyendo después de reset)
    if (!consigneName) {
      setInputConsignerValue("");
      setDebouncedValue("");
      setConsigneeArr([]);
      return;
    }

    const handler = setTimeout(() => {
      setDebouncedValue(consigneName);
    }, 500);

    return () => clearTimeout(handler);
  }, [consigneName]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (inputConsignerValue) {
        setDebouncedValue(inputConsignerValue);
      } else {
        setConsigneeArr([]);
      }
    }, 500);

    return () => clearTimeout(handler);
  }, [inputConsignerValue]);

  useEffect(() => {
    if (debouncedValue && debouncedValue.trim() !== "") {
      const fetchData = async () => {
        try {
          const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/setter/search?query=${debouncedValue}`;

          const response = await axios.get(url, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                "heavy-load-token"
              )}`,
            },
          });
          if (response.data.data.results.length === 0) {
            setConsigneeArr([]);
          } else {
            setConsigneeArr(response.data.data.results);
          }
        } catch (error) {
          console.error(error);
          setConsigneeArr([]);
        }
      };
      fetchData();
    } else {
      setConsigneeArr([]);
    }
  }, [debouncedValue]);

  useEffect(() => {
    const subscription = formResetService.onReset().subscribe(() => {
      reset();
      setInputConsignerValue("");
      setDebouncedValue("");
      setConsigneeArr([]);
    });

    return () => subscription.unsubscribe();
  }, [reset]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        inputConsignee.current &&
        !inputConsignee.current.contains(event.target)
      ) {
        setConsigneeArr([]);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Calcular el total de piezas cada vez que cambien los pesos
  useEffect(() => {
    const sum = palletWeights.reduce((acc, curr) => acc + curr, 0);
    setTotalPieces(sum);

    // Actualizar el valor en el formulario (si estás usando react-hook-form)
    if (setValue) {
      setValue("pieces", sum.toString());
    }
  }, [palletWeights]);

  const getTopClients = async () => {
    try {
      const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/setter/top_clients`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
        },
      });

      setTopClientsArr(response.data.data.client);
    } catch (error) {
      console.log(error);
    }
  }

  const handleOptionClick = (name) => {
    setValue("consigne_name", name);
    setConsigneeArr([]);
  };

  const setterSubmit = async (data) => {
    const palletKeys = Object.keys(data).filter((key) =>
      key.startsWith("pallet")
    );
    const pallets = palletKeys
      .map((key) => {
        // Extraer el número de la tarima (ej: 'pallet1' -> 1)
        const palletNumber = parseInt(key.replace("pallet", ""));
        return {
          number: palletNumber,
          pieces: parseInt(data[key]) || 0,
        };
      })
      .sort((a, b) => a.number - b.number);


    const shipment = {
      customer_name: data.customer_name,
      consigne_name: data.consigne_name,
      number_pallets: data.number_pallets,
      pieces: data.pieces,
      destination_id: data.destination_id,
      content: data.content,
      pallets: pallets,
    };

    if (formBtnClick === false) {
      addData(shipment);
      setConfirmationModal(true);
      return;
    }

    Swal.fire({
      title: "¿Quieres agregar otro embarque?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        addData(shipment);
        reset();
        setNumberOfPallets(0);
        setPalletWeights([]);
        setTotalPieces(0);
      }
    });
  };

  const getDestinations = async () => {
    try {
      const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/setter/destination`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
        },
      });
      const filterDestinations = response.data.data.destination.filter(
        (destination) => !destination.name.startsWith("MEX")
      );
      setDestinationArr(filterDestinations);
    } catch (error) {
      console.error(error);
    }
  };

  // Handle changes in the number of pallets
  const handlePalletNumberChange = (e) => {
    const value = e.target.value;
    if (/^[0-9]*$/.test(value)) {
      const num = value === "" ? 0 : parseInt(value);
      const previousCount = numberOfPallets;
      setNumberOfPallets(num);

      if (num > palletWeights.length) {
        setPalletWeights([
          ...palletWeights,
          ...Array(num - palletWeights.length).fill(0),
        ]);
      } else if (num < palletWeights.length) {
        setPalletWeights(palletWeights.slice(0, num));
        for (let i = num + 1; i <= previousCount; i++) {
          unregister(`pallet${i}`);
        }
      }
    }
  };

  // Handle changes in the weight of each pallet
  const handlePalletWeightChange = (index, value) => {
    if (/^[0-9]*$/.test(value)) {
      const newWeights = [...palletWeights];
      newWeights[index] = value === "" ? 0 : parseInt(value);
      setPalletWeights(newWeights);
    }
  };

  return(
    <>
      <form
        className="setter-form"
        autoComplete="off"
        onSubmit={handleSubmit(setterSubmit)}
      >
        <h6>Embarque {getData().length + 1}</h6>

        {/* CLIENT NAME */}
        <div className="heavy-form-group">
          <select
            className="formInput"
            id="customer_name"
            {...register("customer_name", {
              validate: (value) => value !== "client",
            })}
            onChange={(e) => {
              const client = topClientsArr.find(
                (c) => c.customer_name === e.target.value
              );
              if(!client) {
                setValue("consigne_name", "");
                setValue("content", "");
              } else {
                setValue("consigne_name", client.consigne_name ? client.consigne_name : "");
                setValue("content", client.description ? client.description : "");
              }
              
            }}
          >
            <option value="client" className="text-bold">Nombre del cliente</option>
            {topClientsArr.map((client, index) => (
              <option key={index} value={client.customer_name}>
                {client.customer_name}
              </option>
            ))}
          </select>
          {errors.customer_name && isSubmitted && (
            <p>Este campo es requerido</p>
          )}
        </div>

        {/* CONSIGNEE NAME */}
        <div
          className="heavy-form-group consignee-content"
          ref={inputConsignee}
        >
          <input
            id="consigne_name"
            type="text"
            placeholder=" "
            className="formInput"
            {...register("consigne_name", {
              required: true,
              onChange: (e) => setInputConsignerValue(e.target.value),
            })}
            onKeyDown={(e) => {
              if (e.key === "Tab") {
                setConsigneeArr([]);
              }
            }}
          />
          <label htmlFor="consigne_name" className="formLabel">
            Nombre consignatario <span className="text-alert">*</span>
          </label>
          <div
            className={`answer-consignee ${
              consigneeArr.length === 0 ? "" : "active"
            }`}
          >
            {consigneeArr.map((option, index) => (
              <p key={index} onClick={() => handleOptionClick(option.name)}>
                {option.name}
              </p>
            ))}
          </div>
          {errors.consigne_name?.type === "required" && isSubmitted && (
            <p>Este campo es requerido</p>
          )}
        </div>

        {/* CONTAINER INFORMATION */}
        <div className="heavy-form-group">
          <input
            id="content"
            type="text"
            placeholder=" "
            className="formInput"
            {...register("content", {
              maxLength: {
                value: 240,
                message: "Máximo 240 caracteres",
              },
            })}
          />
          <label htmlFor="content" className="formLabel">
            Información del contenedor
          </label>
          {errors.content?.type === "required" && isSubmitted && (
            <p>Este campo es requerido</p>
          )}
          {errors.content?.type === "maxLength" && (
            <p>{errors.content?.message}</p>
          )}
        </div>

        {/* TARIMAS */}
        <div className="heavy-form-group">
          <input
            id="number_pallets"
            type="text"
            placeholder=" "
            className="formInput"
            {...register("number_pallets", {
              required: true,
              pattern: {
                value: /^[0-9]*$/,
                message: "Solo se permiten números",
              },
              onChange: (e) => handlePalletNumberChange(e),
            })}
          />
          <label htmlFor="number_pallets" className="formLabel">
            Cantidad de tarimas de este embarque{" "}
            <span className="text-alert">*</span>
          </label>
          {errors.number_pallets?.type === "required" && isSubmitted && (
            <p>Este campo es requerido</p>
          )}
          {errors.number_pallets?.type === "pattern" && (
            <p>{errors.number_pallets?.message}</p>
          )}
        </div>

        {/* TARIMAS TABLE */}
        {/* Contenedor de tarimas - solo visible si hay tarimas */}
        {numberOfPallets > 0 && (
          <div className="pallet-container">
            {Array.from({ length: numberOfPallets }).map((_, index) => (
              <div key={index} className="two-inputs-contain">
                <div className="heavy-form-group pallet-label">
                  Tarima {index + 1}
                </div>
                <div className="heavy-form-group">
                  <input
                    type="text"
                    id={`pallet${index}`}
                    placeholder=" "
                    className="formInput"
                    value={palletWeights[index] || 0}
                    {...register(`pallet${index + 1}`, {
                      required: true,
                      min: {
                        value: 1,
                        message: "No puede tener 0 piezas",
                      },
                      pattern: {
                        value: /^[0-9]*$/,
                        message: "Solo se permiten números",
                      },
                    })}
                    onChange={(e) =>
                      handlePalletWeightChange(index, e.target.value)
                    }
                  />
                  <label className="formLabel">
                    Piezas en la tarima {index + 1}{" "}
                    <span className="text-alert">*</span>
                  </label>
                  {isSubmitted && errors[`pallet${index + 1}`] && (
                    <p>{errors[`pallet${index + 1}`].message}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* TWO INPUTS */}
        <div className="two-inputs-contain">
          <div className="heavy-form-group">
            <input
              id="pieces"
              type="text"
              value={totalPieces}
              placeholder=" "
              className="formInput"
              disabled
              style={{ backgroundColor: "#a3a3a3" }}
              {...register("pieces", {
                required: true,
                pattern: {
                  value: /^[0-9]*$/,
                  message: "Solo se permiten números",
                },
              })}
            />
            <label htmlFor="pieces" className="formLabel">
              Piezas totales
            </label>
            {errors.pieces?.type === "required" && isSubmitted && (
              <p>Este campo es requerido</p>
            )}
            {errors.pieces?.type === "pattern" && (
              <p>{errors.pieces?.message}</p>
            )}
          </div>

          <div className="heavy-form-group">
            <select
              className="formInput"
              id="destination_id"
              {...register("destination_id", {
                validate: (value) => value !== "destino",
              })}
            >
              <option value="destino">Destino</option>
              {destinationArr.map((destination, index) => (
                <option key={index} value={destination.id}>
                  {destination.name}
                </option>
              ))}
            </select>
            {errors.destination_id && isSubmitted && (
              <p>Este campo es requerido</p>
            )}
          </div>
        </div>

        <div className="btn-container">
          <button
            type="submit"
            onClick={() => {
              formBtnClick = true;
            }}
          >
            Siguiente Embarque <FaAngleRight />
          </button>
        </div>

      </form>
    </>
  )
}

export default SetterTopClientForm;